import { useAuth, UserType } from "@/hooks/useAuth"
import { useNavigate } from "react-router-dom"
import { useLanguage } from "@/hooks/useLanguage"
import { useEffect } from "react"

interface ProtectedRouteProps {
  children: React.ReactNode
  allowedRoles?: UserType[]
  redirectTo?: string
}

const ProtectedRoute = ({
  children,
  allowedRoles = [],
  redirectTo = "/login",
}: ProtectedRouteProps) => {
  const { user, loading } = useAuth()
  const navigate = useNavigate()
  const { t } = useLanguage()
  const text = t.common

  useEffect(() => {
    if (!loading) {
      if (!user) {
        navigate(redirectTo)
        return
      }

      if (allowedRoles.length > 0 && !allowedRoles.includes(user.userType)) {
        navigate("/")
        return
      }
    }
  }, [user, loading, navigate, allowedRoles, redirectTo])

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-lg">{text.loading}</div>
      </div>
    )
  }

  if (!user) {
    return null
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(user.userType)) {
    return null
  }

  return <>{children}</>
}

export default ProtectedRoute

